<template>
  <div id="paymentCaution">
    <div class="input_list">
      <div class="dd_text">
        <h2>クレジットカードでお支払い：</h2>
        <ul class="text_li">
          <li>以下のマークがついているクレジットカードでお支払い頂けます。</li>
          <li>ご注文の確認が出来次第、製造を開始いたします。</li>
          <li>
            <img :src="getImage('bunner/card.webp')">
          </li>
        </ul>
      </div>
      <div class="dd_text">
        <h2>金融機関でのお支払い：</h2>
        <ul class="text_li">
          <li>商品は入金確認後に製造開始いたします。</li>
          <li>お振込み期限を過ぎますと希望納期に間に合わない場合はございます。</li>
          <li>次ページの決済ページにより振込期限をご確認の上、期間内にお支払いいただけますようお願い致します。</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'

export default {
  name: 'PaymentCaution',
  components: {
  },
  props: {
    index: Number,
    itemData: Object
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/order/DcPaymentCaution.vue